import CompaniesEngagementStats from './CompaniesEngagementStats';
import IdeaEngagementStats from './IdeaEngagementStats';
import PostsEngagementStats from './PostsEngagementStats';
import UsersEngagementStats from './UsersEngagementStats';

function InsightsGraphs() {
  return (
    <div className="grid gap-6">
      <UsersEngagementStats />
      <PostsEngagementStats />
      <CompaniesEngagementStats />
      <IdeaEngagementStats />
    </div>
  );
}

export default InsightsGraphs;
